const MAX_DESCRIPTION_LENGTH = 180;

function safeDescription(error) {
  const message =
    error instanceof Error ? error.message : typeof error === "string" ? error : "Unknown client error";
  return message.slice(0, MAX_DESCRIPTION_LENGTH);
}

/**
 * Small, vendor-neutral error reporting bridge.
 *
 * Errors remain visible in the console during development and are also sent as
 * GA4 exception events when gtag is available. A future Sentry/Datadog adapter
 * can subscribe to the `lusuku:client-error` event without changing callers.
 */
export function reportClientError(error, context = {}) {
  const description = safeDescription(error);
  const payload = {
    description,
    fatal: false,
    ...context,
  };

  // eslint-disable-next-line no-console
  console.error(`[${context.area || "client"}] ${description}`, error);

  if (typeof window === "undefined") return;

  try {
    window.dispatchEvent(new CustomEvent("lusuku:client-error", { detail: payload }));
  } catch (_) {
    // Reporting must never break the customer flow.
  }

  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "exception", payload);
    }
  } catch (_) {
    // Analytics is best-effort only.
  }
}

export default reportClientError;
